"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.apiTool.name': 'Richiesta API',
    'tools.apiTool.description': 'Raccoglie dati dalla conversazione e invia richieste API a endpoint esterni configurati',
};
